import React, { Component, useState, useEffect,useRef  } from 'react'
import { withTranslation, Trans , useTranslation} from 'react-i18next';
import OfflineDb from '../../db'
import { styled } from "@material-ui/styles";
import Box from '@material-ui/core/Box';
import Paper from '@material-ui/core/Paper';
import Grid from '@material-ui/core/Grid';
import classes from '../../App.module.css'
import { apiServices } from '../../services/apiServices';
import {useHistory} from "react-router-dom";
import {useGlobalSpinnerActionsContext} from '../../context/GlobalSpinnerContext'
import { useLocation } from "react-router-dom";

import _ from 'lodash';

import FormControl from '@material-ui/core/FormControl';
import Radio from '@material-ui/core/Radio';
import RadioGroup from '@material-ui/core/RadioGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import FooterMenu from '../../component/layout/FooterMenu'

import FormLabel from '@material-ui/core/FormLabel';
const Item = styled(Paper)(({ theme }) => ({
backgroundColor: theme.palette.mode === 'dark' ? '#1A2027' : '#fff',
...theme.typography.body2,
padding: theme.spacing(1),
textAlign: 'center',
color: theme.palette.text.secondary,
}));

function DataEntry() {
    const [dataSets, setDataSets] = useState(null)
    const [surveyMetaData, setSurveyMetaData] = useState(null)
    const setGlobalSpinner = useGlobalSpinnerActionsContext()
    const history = useHistory();
    const [value, setValue] = useState(0)
    const [dataSetname, setdataSet] = useState(null)
    const {t} = useTranslation()
   const location = useLocation();
    const prevPathRef = useRef(null);// "PUSH", "POP", or "REPLACE"

    async function fetchDataFromDataBase() {
        let dataset = await OfflineDb.getDataFromPouchDB('dataEntrySet')
        const showDataSet = location?.state?.dataSet?.datasets ? location?.state?.dataSet?.datasets : dataset.data.dataSets
        setdataSet(location?.state?.dataSet)
        const filteredDataSets = dataset.data.dataSets.filter(ds =>
            showDataSet.includes(ds.discription) || showDataSet.includes(ds.displayName)
            );
        setDataSets(filteredDataSets)
        if(dataset.data && dataset.data.dataSets && dataset.data.dataSets.length > 0){
            setValue(dataset.data.dataSets[0].id)
        }
        
    }

    useEffect(() => {
        fetchDataFromDataBase()
        OfflineDb.removeDataFromPouchDB("activeCaseDetails");
        OfflineDb.removeDataFromPouchDB("activeCaseFormData");
    }, [])


    const getTranslatedLabels = (dataElement) => {
        if (localStorage.getItem("locale") == "en") {
            return dataElement.displayName;
        } else if (dataElement.translations && dataElement.translations.length > 0) {
            let label = dataElement.translations.filter(
                (tanslation) =>
                    tanslation.property == "NAME" &&
                    tanslation.locale == localStorage.getItem("locale")
            );
            if (label.length > 0) {
                return label[0].value;
            } else {
                return dataElement.displayName;
            }
        }
        return dataElement.displayName;
    };

    function onDataSetClick(dataSetId, dataSet) {
        //optionSet[id,options[id,code,displayName,translations[*],style]]
        //console.log("dataSets", dataSets,dataSetId,dataSets.data);
        console.log("onDataSetClick",dataSetId, dataSet);
        //return;
        if(dataSets){
            let selectedDataSet = _.find(dataSets,{"id":dataSetId})
            console.log("selectedDataSet",selectedDataSet);
            OfflineDb.setDataIntoPouchDB('surveyFormData', selectedDataSet)
            OfflineDb.setDataIntoPouchDB('currentDataSet', dataSetId)
            .then(res => {
                setGlobalSpinner(false)
                history.push({pathname:'/layout/datasetmanagement', 
                    state: { dataSet: dataSet }})
                })
        }else{
            const getDataOfSurveyApi = 'dataSets/'+dataSetId+'?fields=all,attributeValues[:all,attribute[id,name,displayName]],dataSetElements[id,dataSet[id],dataElement[:all,id,displayName,categoryCombo[id,displayName],optionSet[id,options[id,code,displayName]]],categoryCombo[id,displayName],optionSet[id,options[id,code,displayName]]],indicators[id,displayName,categoryCombo[id,displayName]],organisationUnits[id,path],sections[:all,dataElements[id,displayName],categoryCombos[id,displayName],,greyedFields[categoryOptionCombo[id,displayName],dataElement[id,displayName]]]'
            setGlobalSpinner(true)
            apiServices.getAPI(getDataOfSurveyApi)
            .then(getDataOfSurvey => {
                console.log("getDataOfSurvey",getDataOfSurvey,getDataOfSurvey.data);
                OfflineDb.setDataIntoPouchDB('surveyFormData', getDataOfSurvey.data)
                OfflineDb.setDataIntoPouchDB('currentDataSet', dataSetId)
                .then(res => {
                    setGlobalSpinner(false)
                    history.push('/layout/survey')
                })
            })
            .catch(err => {
                setGlobalSpinner(false)
            })
        }
    }

    function handleChange(event) {
        console.log("event",event.target.value);
        setValue(event.target.value)
        //onDataSetClick(event.target.value)
    }

    function createGrids() {
        console.log("dataSets",dataSets);
        /*if(dataSets.length != 1){
            OfflineDb.setDataIntoPouchDB('surveyFormData', dataSets[0])
            OfflineDb.setDataIntoPouchDB('currentDataSet',dataSets[0].id)
            history.push('/layout/survey')
        }else{*/
            return (
                dataSets && dataSets.length > 0 ?
                <div className="homemenudivcontainer1 regformsubmitbtn1 survey-module" style={{"width":"100%"}}>
                    <Grid container spacing={2} columns={12}>
                    {
                    dataSets.map((dataSet, index) => {
                            //return <div class="flex-item" onClick={() => onDataSetClick(dataSet.id)}>{getTranslatedLabels(dataSet)}</div>
                           return (
                                <Grid item xs={12} sm={2} md={3} onClick={() => onDataSetClick(dataSet.id, dataSetname)} style={{cursor:"pointer"}}>
                                    <Item className='highlighted-box'>{getTranslatedLabels(dataSet)}</Item>
                                </Grid>
                            //  <div className="highlighted-box" onClick={() => onDataSetClick(dataSet.id)}>
                            //     <i className="fas fa-star"></i>
                            //     <p>{getTranslatedLabels(dataSet)}</p>
                            // </div>
                            )
                        })
                    }
                    </Grid>
                    {/* <FormControl component="fieldset">
                        <RadioGroup aria-label="gender" name="select-form" value={value} onChange={handleChange}>
                            {dataSets.map((dataSet, index) => {
                                return (
                                    <FormControlLabel className={dataSet.displayName == "Tues_21_6_001"? 'hide' :''} style={{"textAlign":"left"}} value={dataSet.id} control={<Radio />} label={getTranslatedLabels(dataSet)} />    
                                )
                            })}
                        </RadioGroup>
                    </FormControl> 
                    <div className="buttons" style={{"textAlign":"left","marginTop":"10px"}}>
                        <button style={{"width":"","maxWidth":""}} className="regformsubmitbtn" type="submit" onClick={() => onDataSetClick(value)}>
                            {t('Submit')}
                        </button>
                    </div>*/}
                </div>
                :<>{t("No datasets found")}</>
            )
        //}
        
    }

    return (
        <div className={classes.container}>
            <FooterMenu></FooterMenu>
            <main style={{ display: 'flex', height: '100%', width: '100%' }}>
                <section className="homepagebgsection dataentrypage rightsectiontoppart"
                   style={{
                    flexGrow: 1,
                    padding: 20,
                    maxHeight: "calc(100vh - 60px)", // Adjust based on layout
                    overflowY: "auto",
                }}
                >
                    <Grid container spacing={3} className="mt-56px">
                        <Grid item xs={12}>
                            <Grid container sm={12} md={12} lg={12} spacing={3} className="progresscontainer homemenuholder1">
                                {dataSets != null && location?.state?.dataSet != null && location?.state?.dataSet?.datasets?.length > 0 
                               
                                ? 
                                    createGrids()
                                :
                                    <> </>
                                }
                            </Grid>
                        </Grid>
                    </Grid>
                </section>
            </main>
        </div>
    )
}

export default DataEntry